import React from "react";
import ReactDOM from "react-dom";
import moment from "moment";
import { DateRangePicker } from "react-date-range";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { IoIosRefresh } from "react-icons/io";
import { defaultStaticRanges } from "./dateRange";

import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file

class DatePicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: this.props.startDate === "" || this.props.startDate === null ? new Date() : this.props.startDate,
      endDate: this.props.endDate === "" || this.props.endDate === null ? new Date() : this.props.endDate,
      key: "selection",
      showPiker: false,
    };
    this.handleSelect = this.handleSelect.bind(this);
    this.handelDates = this.handelDates.bind(this);
  }
  componentDidMount() {
    this.handelDates();
    document.addEventListener("click", this.handleClickOutside, true);
  }


  componentDidUpdate(prev) {
    if (this.props.startDate !== prev.startDate || this.props.endDate !== prev.endDate) {
      this.handelDates();
    }
  }
  handelDates() {
    this.setState(
      {
        startDate: this.props.startDate === "" || this.props.startDate === null ? new Date() : this.props.startDate,
        endDate: this.props.endDate === "" || this.props.endDate === null ? new Date() : this.props.endDate,
      },
      () => {
        if (this.props.startDate !== "" && this.props.startDate !== null && this.props.endDate !== "" && this.props.endDate !== null) {
          this.setState({
            date: moment(new Date(this.state.startDate)).format("DD-MM-YYYY") + " - " + moment(new Date(this.state.endDate)).format("DD-MM-YYYY"),
          });
        } else {
          this.setState({
            date: "",
          });
        }
      }
    );
  }
  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside, true);
  }
  handleClickOutside = (event) => {
    const domNode = ReactDOM.findDOMNode(this);
    if (!domNode || !domNode.contains(event.target)) {
      if (this.state.showPiker) {
        let dates = {
          startDate: this.state.startDate,
          endDate: this.state.endDate,
        };
        this.props.handleSelect(dates);

        this.setState({
          showPiker: false,
        });
      }
    }
  };

  handleSelect(date) {
    if (date.selection.startDate !== undefined && date.selection.endDate !== undefined) {
      this.setState({
        startDate: date.selection.startDate,
        endDate: date.selection.endDate,
        showPiker: true,
        date: moment(new Date(date.selection.startDate)).format("DD-MM-YYYY") + " - " + moment(new Date(date.selection.endDate)).format("DD-MM-YYYY"),
      });
    }
  }

  resetDate = (e) => {
    e.preventDefault();
    this.setState(
      {
        startDate: null,
        endDate: null,
        showPiker: false,
        date: "",
      },
      () => {
        let dates = {
          startDate: this.state.startDate,
          endDate: this.state.endDate,
        };
        this.props.handleSelect(dates);
      }
    );
  };

  render() {
    const selection = {
      startDate: this.state.startDate ? new Date(this.state.startDate) : null,
      endDate: this.state.endDate ? new Date(this.state.endDate) : null,
      key: "selection",
    };

    return (
      <React.Fragment>
        {this.state.showPiker ? (
          <DateRangePicker
            ranges={[selection]}
            onChange={(item) => this.handleSelect(item)}
            showSelectionPreview={true}
            moveRangeOnFirstSelection={false}
            direction="horizontal"
            months={2}
            showPreview={true}
            maxDate={new Date()}
            staticRanges={defaultStaticRanges}
          />
        ) : (
          <input
            placeholder={this.props.placeholder || "Select Date"}
            type="text"
            className="form-control"
            value={this.state.date}
            onFocus={() => this.setState({ showPiker: true })}
          ></input>
        )}

        {this.state.startDate || this.state.endDate ? (
          <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Reset Date</Tooltip>}>
            <button style={{ background: "transparent", border: "0" }} className="btn btn-icon pl-0" onClick={this.resetDate}>
              <IoIosRefresh color="red" size="20" />
            </button>
          </OverlayTrigger>
        ) : (
          ""
        )}
      </React.Fragment>
    );
  }
}

export default DatePicker;
